"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("react-query");
var _noop = _interopRequireDefault(require("lodash/noop"));
var _core = require("@folio/stripes/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// DEFAULT ASSUMES PUT/POST goes to ENDPOINT/id and that POST goes to ENDPOINT
// A utility function to provide this all-in-one functionality used in various places

const useMutateGeneric = function () {
  let {
    afterQueryCalls: {
      delete: afterQueryDelete = _noop.default,
      post: afterQueryPost = _noop.default,
      put: afterQueryPut = _noop.default
    } = {},
    catchQueryCalls: {
      delete: catchQueryDelete = _noop.default,
      post: catchQueryPost = _noop.default,
      put: catchQueryPut = _noop.default
    } = {},
    endpoint,
    endpointMutators: {
      delete: endpointMutatorDelete = id => `${endpoint}/${id}`,
      post: endpointMutatorPost = () => endpoint,
      put: endpointMutatorPut = data => `${endpoint}/${data.id}`
    } = {},
    payloadMutators: {
      post: payloadMutatorPost = data => ({
        json: data
      }),
      put: payloadMutatorPut = data => ({
        json: data
      })
    } = {},
    promiseReturns: {
      delete: promiseReturnDelete = (id, ky) => ky.delete(endpointMutatorDelete(id)).json(),
      post: promiseReturnPost = (data, ky) => ky.post(endpointMutatorPost(data), payloadMutatorPost(data)).json(),
      put: promiseReturnPut = (data, ky) => ky.put(endpointMutatorPut(data), payloadMutatorPut(data)).json()
    } = {},
    queryKey = [],
    // Must be type: array
    queryKeyMutators: {
      delete: queryKeyMutatorDelete = () => [...queryKey, 'delete'],
      post: queryKeyMutatorPost = () => [...queryKey, 'create'],
      put: queryKeyMutatorPut = () => [...queryKey, 'edit']
    } = {},
    queryParams: {
      delete: queryParamsDelete = {},
      post: queryParamsPost = {},
      put: queryParamsPut = {}
    } = {},
    returnQueryObject: {
      delete: returnQueryObjectDelete = false,
      post: returnQueryObjectPost = false,
      put: returnQueryObjectPut = false
    } = {}
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const ky = (0, _core.useOkapiKy)();

  // DELETE Object
  const deleteQueryObject = (0, _reactQuery.useMutation)(queryKeyMutatorDelete(), async id => promiseReturnDelete(id, ky).then(res => afterQueryDelete(res)).catch(catchQueryDelete), queryParamsDelete);

  // Edit Object
  const putQueryObject = (0, _reactQuery.useMutation)(queryKeyMutatorPut(), async data => promiseReturnPut(data, ky).then(afterQueryPut).catch(catchQueryPut), queryParamsPut);

  // Create Object
  const postQueryObject = (0, _reactQuery.useMutation)(queryKeyMutatorPost(), async data => promiseReturnPost(data, ky).then(afterQueryPost).catch(catchQueryPost), queryParamsPost);
  const returnObj = {};
  if (returnQueryObjectDelete) {
    returnObj.delete = deleteQueryObject;
  } else {
    returnObj.delete = deleteQueryObject.mutateAsync;
  }
  if (returnQueryObjectPut) {
    returnObj.put = putQueryObject;
  } else {
    returnObj.put = putQueryObject.mutateAsync;
  }
  if (returnQueryObjectPost) {
    returnObj.post = postQueryObject;
  } else {
    returnObj.post = postQueryObject.mutateAsync;
  }
  return returnObj;
};
var _default = exports.default = useMutateGeneric;